import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { isPrePackProduct, isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { IQuickAdd } from "@faire/web-api--source/indigofair/data/IQuickAdd";
/**
 * Legacy converter to extract quick add data from product.
 *
 * There should be no new uses of this. Instead server should implement this logic and pass quick add data to the client.
 */ export var LegacyIQuickAddConverter = /*#__PURE__*/ function() {
    "use strict";
    function LegacyIQuickAddConverter(product, strictLocalize) {
        var _this = this;
        _class_call_check(this, LegacyIQuickAddConverter);
        this.strictLocalize = strictLocalize;
        this.getProductHasRequiredCustomization = function() {
            var _this_product_customizations, _this_product;
            return (_this_product = _this.product) === null || _this_product === void 0 ? void 0 : (_this_product_customizations = _this_product.customizations) === null || _this_product_customizations === void 0 ? void 0 : _this_product_customizations.some(function(param) {
                var required = param.required, active = param.active;
                return !!required && !!active;
            });
        };
        this.getQuickAddText = function() {
            var chooseOptionsLocalization = _this.strictLocalize({
                id: "zNp7hC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Choose Options"
                    }
                ]
            });
            if (_this.options.length > 1) {
                return chooseOptionsLocalization;
            }
            if (_this.getProductHasRequiredCustomization()) {
                return _this.strictLocalize({
                    id: "ZIQyei",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add Customization"
                        }
                    ]
                });
            }
            if (isPrePackProduct(_this.product)) {
                return _this.strictLocalize({
                    id: "EaR4eI",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "+ Quick Add Pack"
                        }
                    ]
                });
            }
            // placing this after prepack because of precedence
            if (_this.product.per_style_min_order_quantity) {
                return chooseOptionsLocalization;
            }
            return _this.strictLocalize({
                id: "nzrCXW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "+ Quick Add Case"
                    }
                ]
            });
        };
        this.getQuickAddOption = function(option) {
            return IQuickAdd.IQuickAddOption.build({
                option_token: option.token,
                option_unit_multiplier: option.unit_multiplier,
                option_min_order_quantity: isPrePackProductOption(option) ? 1 : _this.product.min_order_quantity,
                option_available_units: _this.product.allow_sales_when_out_of_stock ? undefined : option.available_units
            });
        };
        this.product = product;
        this.options = product.options;
    }
    var _proto = LegacyIQuickAddConverter.prototype;
    // Disabling because unit tests spy on the prototype
    // eslint-disable-next-line @faire/prefer-arrow-methods
    _proto.toIQuickAdd = function toIQuickAdd() {
        return IQuickAdd.build({
            quick_add_text: this.getQuickAddText(),
            quick_add_option: this.options.length === 1 && !this.getProductHasRequiredCustomization() && this.options[0] ? this.getQuickAddOption(this.options[0]) : undefined
        });
    };
    return LegacyIQuickAddConverter;
}();
